<h1 mat-dialog-title>{{ 'CHANGE-LANGUAGE-DIALOG.LANGUAGE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'CHANGE-LANGUAGE-DIALOG.LOGOUT-MESSAGE' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="profile-change-lang-btn" mat-flat-button (click)="changeLang()">{{ 'CHANGE-LANGUAGE-DIALOG.YES' | translate }}</button>
    <button class="profile-change-lang-btn" mat-flat-button(click)="cancel()">{{ 'CHANGE-LANGUAGE-DIALOG.NO' | translate }}</button>
</div>
